import {useMemo} from 'react';
import {FileRejection, useDropzone} from 'react-dropzone';

const StyledDropzoneComponent = (props: any) => {

    const onFileAccepted: any = props.onFileAccepted
    const onFileRejected: any = props.onFileRejected
    const maxFiles: number = props.maxFiles

    const baseStyle = {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px',
        borderWidth: 2,
        borderRadius: 2,
        borderColor: '#eeeeee',
        borderStyle: 'dashed',
        backgroundColor: '#fafafa',
        color: '#bdbdbd',
        outline: 'none',
        transition: 'border .24s ease-in-out'
    };

    const focusedStyle = {
        borderColor: '#2196f3'
    };

    const acceptStyle = {
        borderColor: '#00e676'
    };

    const rejectStyle = {
        borderColor: '#ff1744'
    };

    const {
        getRootProps,
        getInputProps,
        isFocused,
        isDragAccept,
        isDragReject
    } = useDropzone(
        {
            accept: {'image/*': []},
            onDrop: (acceptedFiles: File[], fileRejections: FileRejection[] ) => {
                if (acceptedFiles.length > 0) {
                    onFileAccepted(acceptedFiles)
                }

                if(fileRejections.length > 0) {
                    const code: string = fileRejections[0].errors[0].code
                
                    let reason: string = "Unknown error."
                    if (code == "file-invalid-type") {
                        reason = "File must be .jpg"
                    }
                    onFileRejected(reason)
                }
            },
            maxFiles: maxFiles,
            useFsAccessApi: false
        }
    );

    const style: any = useMemo(() => ({
        ...baseStyle,
        ...(isFocused ? focusedStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
        isFocused,
        isDragAccept,
        isDragReject
    ]);

    return (
        <div className="container">
            <div {...getRootProps({style})}>
                <input {...getInputProps()} />
                {props.children}
            </div>
        </div>
    );
    
}

export default StyledDropzoneComponent